import { useEffect, useState, useMemo } from 'react';
// Design System
import Heading from 'components/design-system/Heading/Heading';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import Text from 'components/design-system/Text/Text';

// Hooks
import { SelectorDireccionContainer } from 'hooks/Selectors/hooks';

// Utils
import {
  handleKeyPress,
  handlePaste
} from 'views/Business/utils/handleKeyPress';

// Components
import { CircularProgress } from '@mui/material';

const GeneradorVendedor = ({
  // Formik
  errors,
  handleBlur,
  handleChange,
  // handleReset,
  // handleSubmit,
  isSubmitting,
  // setFieldError,
  setFieldTouched,
  setFieldValue,
  touched,
  // validateForm,
  values,
  // Dependencias

  // Empresas SII
  empresasSII,
  cargaEmpresasSII,
  isLoadingEmpresasSII,

  // Tipo Formulario
  tipoForm
}) => {
  const [razonSocial, setRazonSocial] = useState('');

  const { duplicar, editar } = tipoForm;

  useEffect(() => {
    if (!empresasSII) return;
    if (empresasSII.razonSocial) {
      setRazonSocial(empresasSII.razonSocial);
      setRazonSocial(empresasSII.razonSocial);
      setFieldValue('nombreEmpresaGenerador', empresasSII.razonSocial);
    } else {
      setRazonSocial('Sin información');
    }
  }, [empresasSII, isLoadingEmpresasSII]);

  // Carga RUT al ingresar al formulario
  useMemo(() => {
    if ((duplicar || editar) && !touched.rut && values.rut) {
      cargaEmpresasSII(values.rut);
    }
  }, [cargaEmpresasSII, duplicar, editar, touched.rut, values.rut]);

  return (
    <>
      <div className="col-span-12">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-12">
            <Heading type="h4" className="mb-0">
              Generador - Vendedor del recurso
            </Heading>
          </div>
          <div className="col-span-12 xs:col-span-12">
            <div className="grid grid-cols-12 gap-4">
              {/* RUT */}
              <div className="col-span-12 sm:col-span-4">
                <InputComponent
                  autoComplete="off"
                  disabled={isSubmitting}
                  fullWidth
                  name={'rut'}
                  value={values.rut || ''}
                  onChange={event => {
                    const { value } = event.target;
                    setFieldTouched('nombreLER', true);

                    // verificar si el rut es valido

                    if (
                      value.length >= 9 &&
                      value.charAt(value.length - 2) === '-'
                    ) {
                      setFieldValue('rut', value.trim());
                      cargaEmpresasSII(value);
                    } else {
                      setFieldValue('rut', value.trim());
                      setRazonSocial('Sin información');
                    }
                  }}
                  onBlur={() => {
                    setFieldTouched('rut');
                  }}
                  outerInputProps={{
                    inputProps: {
                      maxLength: 12,
                      // minLenth: 9,
                      onKeyPress: handleKeyPress
                    }
                  }}
                  onPaste={handlePaste}
                  touched={touched.rut}
                  placeholder="Ej: 12345678-9"
                  estado={
                    errors.rut ? { tipo: 'error', mensaje: errors.rut } : null
                  }
                  label={<LabelComponent>Rut </LabelComponent>}
                />
              </div>
              <div className="col-span-12 sm:col-span-4">
                <LabelComponent
                  tooltipText={
                    <>
                      <b>La razón social</b> ha sido{' '}
                      <b>obtenida de forma automática</b> con la información
                      entregada por el{' '}
                      <b>Servicio de Impuestos Internos (SII).</b>
                    </>
                  }
                >
                  Razón social
                </LabelComponent>
                <div className="rounded bg-neutral-90 p-2.5 relative">
                  <Text className="min-h-[1.25rem]">
                    {empresasSII &&
                    empresasSII.razonSocial &&
                    !isLoadingEmpresasSII &&
                    !errors.rut &&
                    touched.rut
                      ? razonSocial
                      : !touched.rut && !errors.rut
                      ? ''
                      : 'Sin información'}
                  </Text>

                  {isLoadingEmpresasSII && touched.rut && !errors.rut && (
                    <CircularProgress
                      color="inherit"
                      className="opacity-40 !w-5 !h-5 absolute right-2.5 top-2.5"
                    />
                  )}
                </div>
              </div>
              {/* Nombre */}
              <div className="col-span-12 md:col-span-4">
                <InputComponent
                  autoComplete="off"
                  disabled={isSubmitting}
                  fullWidth
                  name={'nombreEmpresaGenerador'}
                  value={values.nombreEmpresaGenerador || ''}
                  onChange={handleChange}
                  onBlur={() => {
                    setFieldTouched('nombreEmpresaGenerador');
                  }}
                  touched={touched.nombreEmpresaGenerador}
                  estado={
                    errors.nombreEmpresaGenerador
                      ? {
                          tipo: 'error',
                          mensaje: errors.nombreEmpresaGenerador
                        }
                      : null
                  }
                  label={
                    <LabelComponent
                      tooltipText={
                        <>
                          <b>Nombre de fantasía</b> que sirve para{' '}
                          <b>agrupar los residuos declarados</b> de esta
                          empresa. Si se obtuvo <b>el dato de razón social</b>{' '}
                          este <b>será sugerido como nombre de empresa</b>. Sin
                          embargo puede <b>editar el campo</b> e indicar otro
                          nombre para la empresa.
                        </>
                      }
                    >
                      Nombre empresa{' '}
                    </LabelComponent>
                  }
                />
              </div>

              {/* Refactoring - direccion y mapa */}
              <SelectorDireccionContainer
                values={values}
                errors={errors}
                touched={touched}
                onChange={handleChange}
                handleBlur={handleBlur}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                subtitle=""
                className="grid grid-cols-12 gap-4 mt-2"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneradorVendedor;
